import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { userJoinCompanys } from '@/utils/api/common';

const initialState = {
  list: [],
};

export const asyncCompanyInit = createAsyncThunk("company/asyncCompanyInit", async (_, state) => {
  const { company: { list = [] }, } = state.getState();
  const { data: { data = {}, code }, } = await userJoinCompanys();
  if (+code === 0) {
    const { list = [] } = data;
    return list;
  } else {
    return list;
  }
});


export const slice = createSlice({
  name: "company",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(asyncCompanyInit.fulfilled, (state, actions) => {
        state.list = actions.payload;
      });
  },
});

const { reducer } = slice;
export default reducer;